import React, { useContext } from 'react';
import ForgotPasswordForm from '../features/auth/pages/forgot-password/ForgotPasswordForm';
import useForgotPasswordRequest from '../features/auth/pages/forgot-password/useForgotPasswordRequest';


const ForgotPasswordPage = () => {
    const { forgotPassword } = useForgotPasswordRequest();

    return (
        <ForgotPasswordForm onForgotPasswordSubmit={forgotPassword}/>
    )
}

export default ForgotPasswordPage